import type { OwnerListing } from "../../services/listings.service";
import {
  VIDEO_TOUR_GROUP_MAX_LISTINGS,
  VIDEO_TOUR_THUMBNAIL_PX,
} from "../constants/host-hub-video-tour.consts";
import type { HostHubVideoTourListing } from "../types/model/video-tour-listing";
import { pickListingThumbnailUrl } from "./cloudinary-image.utils";

const toVideoTourListing = ({
  listing,
  listingId,
}: {
  listing: OwnerListing | undefined;
  listingId: string;
}): HostHubVideoTourListing => ({
  id: listingId,
  mediaAlt: listing?.title,
  mediaUrl: pickListingThumbnailUrl({
    images: listing?.images,
    size: VIDEO_TOUR_THUMBNAIL_PX,
  }),
  primaryCtaRoute: `/mylistings/${listingId}/photos`,
  spaceTitle: listing?.title,
  useType: listing?.use_type,
});

/**
 * Maps listing IDs missing a video/3D tour into recommended-card rows, joined
 * with owner-listing documents (`title`, `use_type`, `images`) from
 * `GET /v2/spaces-v2/listings/owner/:sso-id`. Capped at the group max so the
 * next eligible listing surfaces once one gets a video.
 */
export const toVideoTourListings = ({
  incompleteListingIds,
  listings,
}: {
  incompleteListingIds: string[] | undefined;
  listings: OwnerListing[] | undefined;
}): HostHubVideoTourListing[] => {
  const listingById = new Map(
    (listings ?? []).map((listing) => [listing._id, listing]),
  );

  return (incompleteListingIds ?? [])
    .slice(0, VIDEO_TOUR_GROUP_MAX_LISTINGS)
    .map((listingId) =>
      toVideoTourListing({
        listing: listingById.get(listingId),
        listingId,
      }),
    );
};
